var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSituationPersoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-3{mask:url(#mask);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 90.151,
    y: 304.542,
    width: 306.191,
    height: 190.003,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "90.151 304.542 396.342 304.542 396.342 494.537 90.151 494.537 90.151 304.542"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-2",
    d: "M243.246,33.68c61.411,0,111.36,49.641,111.36,110.664s-49.949,110.678-111.36,110.678-111.36-49.655-111.36-110.678S181.835,33.68,243.246,33.68m0,246.885c75.858,0,137.368-60.981,137.368-136.221S319.1,8.137,243.246,8.137,105.879,69.118,105.879,144.344s61.509,136.221,137.367,136.221"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "cls-2",
    d: "M237.607,468.988a309.934,309.934,0,0,1-72.178-8.769L159.4,339.09a79.6,79.6,0,0,1,25.356-8.227,100.235,100.235,0,0,0,120.2.542,80.069,80.069,0,0,1,18.593,6.059l-6.042,120.99a311.517,311.517,0,0,1-79.9,10.534m59.119-164.252-2.6,2.321a73.732,73.732,0,0,1-100.478-2.515C136.28,305.848,90.151,351.848,90.151,408.507v52.045a336.941,336.941,0,0,0,306.191-5.725v-46.32c0-55.38-44.063-100.519-99.616-103.771"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cls-2",
    d: "M243.246,378.371a9.862,9.862,0,1,0,10.047,9.867,9.95,9.95,0,0,0-10.047-9.867"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "cls-2",
    d: "M243.246,420.063a9.862,9.862,0,1,0,10.047,9.867,9.95,9.95,0,0,0-10.047-9.867"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationPersoIcon);
export default __webpack_public_path__ + "static/media/SituationPersoIcon.44db9d3cb4b5f2632de5b8cfa3f9ebd0.svg";
export { ForwardRef as ReactComponent };